<template>
  <div class="footer img_footer">
    <div class="fotter_content">
      <div class="fotter_content_left">
        <ul>
          <li>
            <a href="https://qyfw.nbyz.gov.cn/wzgl/yssm/index.html">隐私声明</a>
            <span>|</span>
          </li>
          <li>
            <a href="https://qyfw.nbyz.gov.cn/wzgl/wzdt/index.html">网站地图</a>
          </li>
        </ul>
        <p>主办:鄞州区政务服务中心（企业综合服务中心）</p>
        <p>Copyright @ 2023-2025</p>
        <p>最佳使用效果1920*1080分辨率/建议使用Chrome或者IE edge浏览器</p>
      </div>
      <!-- <div class="fotter_content_right">
        <ul>
          <li>
            <div></div>
            <p>鄞州政务</p>
          </li>
          <li>
            <div></div>
            <p>鄞州发布</p>
          </li>
          <li>
            <div></div>
            <p>浙里办</p>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CmsFooter",
  props: {},
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: auto;
  background-color: #000;
}
.footer .fotter_content {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 40px 0;
}
.footer .fotter_content .fotter_content_left ul {
  display: flex;
  margin-bottom: 15px;
  padding: 0;
}
.footer .fotter_content .fotter_content_left ul li {
  display: flex;
  color: #fff;
}
.footer .fotter_content .fotter_content_left ul li a {
  font-size: 22px;
  color: #fff;
}
.footer .fotter_content .fotter_content_left ul li span {
  width: 30px;
  line-height: 2;
  text-align: center;
  font-weight: 700;
}
.footer .fotter_content .fotter_content_left p {
  font-size: 18px;
  color: #999;
  margin: 10px 0;
}
.footer .fotter_content .fotter_content_right ul {
  display: flex;
  justify-content: space-between;
}
.footer .fotter_content .fotter_content_right ul li div {
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}
.footer .fotter_content .fotter_content_right ul li p {
  font-size: 18px;
  text-align: center;
  color: #999;
}
.footer .fotter_content .fotter_content_right ul li:nth-child(1) > div {
  background-image: url(https://qyfw.nbyz.gov.cn/cms_files/filemanager/2052681531/picture/202311/7fc6cc1a89224bcabd5b532b85da0436.png?t=1700993416130);
  background-size: 100%;
}
.footer .fotter_content .fotter_content_right ul li:nth-child(2) > div {
  background-image: url(https://qyfw.nbyz.gov.cn/cms_files/filemanager/2052681531/picture/202311/e78b3bddfbf54dd6b5ad16c56cae395b.png?t=1700993445089);
  background-size: 100%;
}
.footer .fotter_content .fotter_content_right ul li:nth-child(3) > div {
  background-image: url(https://qyfw.nbyz.gov.cn/cms_files/filemanager/2052681531/picture/202311/d07184ab70df43aa9e838290a1d7b9e4.png?t=1700993458259);
  background-size: 100%;
}
.footer .fotter_content .fotter_content_right ul li:nth-child(2) {
  margin: 0 20px;
}
/* 当屏幕宽度小于或等于1200像素时，应用以下样式 */
@media (max-width: 1200px) {
  .footer {
    width: 1200px;
    padding: 0 24px;
  }
}
</style>
